import React from 'react'
import get from 'lodash/get'
import { htmlFromText } from "../../helpers.js"

class TableBlock extends React.Component {
  render() {
    let { sys: { id }, fields: { content, extraAttributes } } = this.props.node

    content = get(content, 'en-US')
    extraAttributes = get(extraAttributes, 'en-US', {})
    
    const extraClasses = get(extraAttributes, 'className', '')
    
    return (
      <div className={`block-table ${extraClasses}`} dangerouslySetInnerHTML={htmlFromText(content)}></div>
    )
  }
}

export default TableBlock
